module.exports = __webpack_public_path__ + "img/ywlcwb_bpo.9af453bb.png";